export default "__VITE_ASSET__DHw5_YFK__"